import { cfgHasSports, toTileCdn } from '@infinitro/config';
export const sportsRocketbet = cfgHasSports()
    ? [
        {
            game: 'soccer-1',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/soccer`)
        },
        {
            game: 'tennis-5',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/tennis`)
        },
        {
            game: 'basketball-2',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/basketball`)
        },
        {
            game: 'mixed-martial-arts-117',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/mma`)
        },
        {
            game: 'ice-hockey-4',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/ice_hockey`)
        },
        {
            game: 'padel-71',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/padel`)
        },
        {
            game: 'american-football-16',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/american_football`)
        },
        {
            game: 'boxing-10',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/boxing`)
        },
        {
            game: 'baseball-3',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/baseball`)
        },
        {
            game: 'darts-22',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/darts`)
        }
    ]
    : [];
